import { faBuilding, faChevronDown, faChevronUp, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './candidateWorkExperience.css';
import { Col, Row, Container } from 'react-bootstrap';
import WorkExperienceIcon from '../../../../assets/images/ic_experience_violet.png';
import { generateColors } from '../../../../utils/colorUtilsClientInfo';
import { useState, useEffect } from 'react';
import { faCirclePause } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';

const CandidateJobRoleDetails = ({ jobDetail, index, isCurrentRole, isEditing, onChange }) => {
  const colours = generateColors(index);
  const [viewMore, setViewMore] = useState(isEditing);
  const [reasons, setReasons] = useState(jobDetail.reasons || '');
  const [designation, setDesignation] = useState(jobDetail.designation || '');
  const [orgName, setOrgName] = useState(jobDetail.orgName || '');
  const [location, setLocation] = useState(jobDetail.location || '');
  const [topThreeResponsibilities, setTopThreeResponsibilities] = useState(jobDetail.topThreeResponsibilities || '');
  const [topThreeAchievements, setTopThreeAchievements] = useState(jobDetail.topThreeAchievements || '');

  useEffect(() => {
    if (isEditing) {
      setViewMore(true);
    }
  }, [isEditing]);

  const handlePromotionChange = (promotionIdx, key, value) => {
    const updatedPromotions = [...(jobDetail.promotions || [])];
    updatedPromotions[promotionIdx] = {
      ...updatedPromotions[promotionIdx],
      [key]: value,
    };
    onChange(index, { promotions: updatedPromotions });
  };

  if (jobDetail.isCareerGap === true) {
    return (
      <Container className="hoverHighlight career-gap-block">
        <Row className="d-flex justify-content-center p-1 mt-1 work-experience-container">
          <Col xs={2} sm={2} lg={1} className="d-flex justify-content-center">
            <span className="rounded-span" style={{ backgroundColor: colours.backgroundColor, color: colours.color }}>
              <FontAwesomeIcon icon={faCirclePause} />
            </span>
          </Col>

          <Col xs={8} sm={8} lg={9}>
            <Row>
              <Col xs={12}>
                <span className="jobTitle">Career Gap</span>
              </Col>
              <Col xs={12}>
                {isEditing ? (
                  <>
                    <input
                      type="month"
                      className="form-control d-inline w-auto me-2"
                      value={
                        jobDetail.startDate
                          ? `${new Date(jobDetail.startDate).getFullYear()}-${String(new Date(jobDetail.startDate).getMonth() + 1).padStart(2, '0')}`
                          : ''
                      }
                      onChange={(e) => onChange(index, { startDate: e.target.value })}
                    />

                    <span className="jobSubTitle2"> to </span>

                    <input
                      type="month"
                      className="form-control d-inline w-auto ms-2"
                      value={
                        jobDetail.endDate
                          ? `${new Date(jobDetail.endDate).getFullYear()}-${String(new Date(jobDetail.endDate).getMonth() + 1).padStart(2, '0')}`
                          : ''
                      }
                      onChange={(e) => onChange(index, { endDate: e.target.value })}
                    />
                  </>
                ) : (
                  <>
                    {jobDetail.startDate && (
                      <span className="jobSubTitle2">
                        {new Date(jobDetail.startDate).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                        })}
                      </span>
                    )}
                    {(jobDetail.startDate || jobDetail.endDate) && (
                      <span className="jobSubTitle2"> to </span>
                    )}
                    {jobDetail.endDate ? (
                      <span className="jobSubTitle2">
                        {new Date(jobDetail.endDate).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                        })}
                      </span>
                    ) : (
                      <span className="jobSubTitle2">Ongoing</span>
                    )}
                  </>
                )}
              </Col>
            </Row>
          </Col>

          <Col xs={2} sm={2} lg={2} className="d-flex align-items-start justify-content-center">
            {jobDetail.reasons && (
              <a
                className="viewMore"
                onClick={(e) => {
                  e.preventDefault();
                  setViewMore(!viewMore);
                }}
              >
                <span className='viewMore'>
                  <span className="viewMoreText">{viewMore ? 'View Less' : 'View More'}</span>
                  <FontAwesomeIcon icon={viewMore ? faChevronUp : faChevronDown} className="viewMoreIcon" />
                </span>
              </a>
            )}
          </Col>
        </Row>

        {viewMore && jobDetail.reasons && (
          <Row className="p-1 mt-1 work-experience-container jobContent pt-2 d-flex justify-content-center align-items-center">
            <Col lg={1}>&nbsp;</Col>
            <Col lg={9} md={8} xs={8}>
              <Row>
                <Col xs={12}>
                  <h5 className="jobDetailsTitle">Reason for Gap</h5>
                  {isEditing ? (
                    <textarea
                      className="form-control"
                      value={reasons}
                      onChange={(e) => {
                        setReasons(e.target.value);
                        onChange(index, { reasons: e.target.value });
                      }} />
                  ) : (
                    <p className="jobDetailsContent">{jobDetail.reasons}</p>
                  )}
                </Col>
              </Row>
            </Col>
            <Col lg={2}>&nbsp;</Col>
          </Row>
        )}
      </Container>
    );
  }


  return (
    <Container className="hoverHighlight">
      <Row className="d-flex justify-content-center  p-1 mt-1 work-experience-container">
        <Col xs={2} sm={2} lg={1} className="d-flex justify-content-center">
          <span className="rounded-span" style={{ backgroundColor: colours.backgroundColor, color: colours.color }}>
            <img src={WorkExperienceIcon} alt="Work Experience Icon" />
          </span>
        </Col>

        <Col xs={8} sm={8} lg={9}>
          <Row>
            <Col xs={12}>
              {isEditing ? (
                <>
                  <span className="jobTitle">
                    <input
                      type="text"
                      className="form-control d-inline w-auto me-2"
                      value={designation}
                      onChange={(e) => {
                        setDesignation(e.target.value);
                        onChange(index, { designation: e.target.value });
                      }}

                      placeholder="Designation"
                    />
                  </span>
                  <span className="jobSubTitle">
                    at{' '}
                    <input
                      type="text"
                      className="form-control d-inline w-auto mx-2"
                      value={orgName}
                      onChange={(e) => {
                        setOrgName(e.target.value);
                        onChange(index, { orgName: e.target.value });
                      }}

                      placeholder="Organization Name"
                    />
                    ,{' '}
                    <input
                      type="text"
                      className="form-control d-inline w-auto ms-2"
                      value={location}
                      onChange={(e) => {
                        setLocation(e.target.value);
                        onChange(index, { location: e.target.value });
                      }}

                      placeholder="Location"
                    />
                  </span>
                </>
              ) : (
                <>
                  <span className="jobTitle">{designation}</span>{' '}
                  <span className="jobSubTitle">
                    at {orgName}, {location}
                  </span>
                </>
              )}
            </Col>

            <Col xs={12}>
              {isEditing ? (
                <>
                  <input
                    type="month"
                    className="form-control d-inline w-auto me-2"
                    value={
                      jobDetail.startDate
                        ? `${new Date(jobDetail.startDate).getFullYear()}-${String(new Date(jobDetail.startDate).getMonth() + 1).padStart(2, '0')}`
                        : ''
                    }
                    onChange={(e) => onChange(index, { startDate: e.target.value })}
                  />
                  <span className="jobSubTitle2"> to </span>
                  <input
                    type="month"
                    className="form-control d-inline w-auto ms-2"
                    value={
                      jobDetail.endDate
                        ? `${new Date(jobDetail.endDate).getFullYear()}-${String(new Date(jobDetail.endDate).getMonth() + 1).padStart(2, '0')}`
                        : ''
                    }
                    onChange={(e) => onChange(index, { endDate: e.target.value })}
                  />
                </>
              ) : (
                <>
                  {jobDetail.startDate && (
                    <span className="jobSubTitle2">
                      {new Date(jobDetail.startDate).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                      })}
                    </span>
                  )}

                  {jobDetail.startDate && jobDetail.endDate && (
                    <>
                      <span className="jobSubTitle2"> to </span>
                      <span className="jobSubTitle2">
                        {new Date(jobDetail.endDate).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                        })}
                      </span>
                    </>
                  )}

                  {!jobDetail.startDate && jobDetail.endDate && (
                    <span className="jobSubTitle2">
                      {new Date(jobDetail.endDate).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                      })}
                    </span>
                  )}

                  {!jobDetail.endDate && isCurrentRole && jobDetail.startDate && (
                    <>
                      <span className="jobSubTitle2"> to </span>
                      <span className="jobSubTitle2">Present</span>
                    </>
                  )}

                </>
              )}

              {/* {isEditing ? (
                <input
                  type="text"
                  className="form-control d-inline w-auto ms-2"
                  placeholder="Industry"
                  value={jobDetail.industry || ''}
                  onChange={(e) => onChange(index, { industry: e.target.value })}
                />
              ) : (
                _.get(jobDetail, 'industry') && (
                  <span className="jobSubTitle3">{' - ' + _.get(jobDetail, 'industry')}</span>
                )
              )} */}
              {!isEditing && jobDetail.industry && (
                <span className="jobSubTitle3">
                  {' - '}
                  {jobDetail.industry}
                  {jobDetail.industrySubcategory && ` (${jobDetail.industrySubcategory})`}
                </span>
              )}

            </Col>
            <Col>{!isEditing && jobDetail.function && (
              <span className="jobSubTitle3">
                <FontAwesomeIcon icon={faBuilding}></FontAwesomeIcon>{' '}
                {jobDetail.function}
                {jobDetail.functionSubcategory && ` (${jobDetail.functionSubcategory})`}
              </span>
            )}</Col>
          </Row>

        </Col>

        <Col xs={2} sm={2} lg={2} className="d-flex align-items-start justify-content-center">
          {(jobDetail.topThreeResponsibilities || (jobDetail.hasPromotions === "YES" && jobDetail.promotions?.length > 0)) && (
            <a
              className="viewMore"
              onClick={(e) => {
                e.preventDefault();
                setViewMore(!viewMore);
              }}
            >
              <span className='viewMore'>
                <span className="viewMoreText">
                  {viewMore ? 'View Less' : 'View More'}
                </span>
                <FontAwesomeIcon
                  icon={viewMore ? faChevronUp : faChevronDown}
                  className="viewMoreIcon"
                />
              </span>
            </a>
          )}
        </Col>

      </Row>

      {viewMore && (
        <Row className="p-1 mt-1 work-experience-container jobContent pt-2 d-flex justify-content-center align-items-center">
          <Col lg={1}>&nbsp;</Col>
          <Col lg={9} md={8} xs={8}>
            <Row>
              {jobDetail.topThreeResponsibilities && (
                <Col lg={12}>
                  <h5 className="jobDetailsTitle">My Top 3 Responsibilities are</h5>
                  {isEditing ? (
                    <textarea
                      className="form-control"
                      value={topThreeResponsibilities}
                      onChange={(e) => {
                        setTopThreeResponsibilities(e.target.value);
                        onChange(index, { topThreeResponsibilities: e.target.value });
                      }} />
                  ) : (
                    <p className="jobDetailsContent" style={{ whiteSpace: 'pre-line' }}>{jobDetail.topThreeResponsibilities}</p>
                  )}
                </Col>
              )}
              {jobDetail.topThreeAchievements && (
                <Col lg={12} className="mt-3">
                  <h5 className="jobDetailsTitle">My Top 3 Achievements are</h5>
                  {isEditing ? (
                    <textarea
                      className="form-control"
                      value={topThreeAchievements}
                      onChange={(e) => {
                        setTopThreeAchievements(e.target.value);
                        onChange(index, { topThreeAchievements: e.target.value });
                      }}
                    />
                  ) : (
                    <p className="jobDetailsContent" style={{ whiteSpace: 'pre-line' }}>
                      {jobDetail.topThreeAchievements}
                    </p>
                  )}
                </Col>
              )}

              {jobDetail.hasPromotions === "YES" && jobDetail.promotions?.length > 0 && (
                <Col lg={12} className="mt-3">
                  <h5 className="jobDetailsTitle">Promotions</h5>
                  <ul className="jobDetailsContent">
                    {jobDetail.promotions.map((promo, idx) => (
                      <li key={`promotion-${idx}`}>
                        {isEditing ? (
                          <>
                            Promoted from{' '}
                            <input
                              type="text"
                              className="form-control d-inline w-auto mx-2"
                              value={promo.previousDesignation}
                              onChange={(e) => handlePromotionChange(idx, 'previousDesignation', e.target.value)}
                              placeholder="Previous Designation"
                            />
                            in{' '}
                            <input
                              type="text"
                              className="form-control d-inline w-auto ms-2"
                              value={promo.promotionYr}
                              onChange={(e) => handlePromotionChange(idx, 'promotionYr', e.target.value)}
                              placeholder="Year"
                            />
                          </>
                        ) : (
                          <>
                            Promoted from <strong>{promo.previousDesignation}</strong> in {promo.promotionYr}
                          </>
                        )}
                      </li>
                    ))}
                  </ul>
                </Col>
              )}

            </Row>
          </Col>
          <Col lg={2}>&nbsp;</Col>
        </Row>
      )}
    </Container>
  );
};

export default CandidateJobRoleDetails;
